<template>
  <hamv-dialog :dialogProps="dialogProps" :showModal="showModal">
    <span class="el-dialog__title" data-qa="Dialog-DeleteFirmware-Title" slot="header">{{ $t('firmwareDeleteDialogTitle') }}</span>
    <i18n path="firmwareDeleteDialogConfirmText" data-qa="Dialog-DeleteFirmware-ConfirmText" tag="span">
      <el-tag place="version" type="info">{{ version }}</el-tag>
    </i18n>
    <div slot="actions">
      <el-button
        :class="button.class"
        :data-qa="`Dialog-DeleteFirmware-Button-${button.id}`"
        :key="index"
        :type="button.type || 'warning'"
        @click.stop="button.click"
        v-for="(button, index) in buttons"
      >
        {{ $t(button.text) }}
      </el-button>
    </div>
  </hamv-dialog>
</template>

<script>
  import main from './FirmwareDelete.js'
  export default main
</script>

<style lang="scss" scoped>
  @import './FirmwareDelete.scss'
</style>



// WEBPACK FOOTER //
// FirmwareDelete.vue?2f31ac51